import React from "react";
import ProductionItemsPage from "Common/Components/ProductionItemsPage";

// کالاهای خارج شده از انبار = قلم‌هایی که item_status آن‌ها out_of_warehouse است.
// تأییدهای بارگیری و حراست در صفحه‌ی وضعیت out_of_warehouse نمایش داده می‌شوند.
const Index = () => (
  <ProductionItemsPage
    pageTitle="کالاهای خارج شده از انبار"
    itemStatus="out_of_warehouse"
    canRevert
    // برگشت خروج از انبار و تأییدهای لجستیک فقط برای ادمین مجاز است.
    revertRoles={[]}
    emptyText="هیچ کالایی خارج‌شده از انبار نیست"
  />
);

export default Index;
